<mat-form-field
  appearance="outline"
  class="w-full dh-like-form-field"
  subscriptSizing="dynamic"
  [hideRequiredMarker]="true"
>
  <mat-label>{{ label() }}</mat-label>
  
  <input 
    matInput 
    [matDatepicker]="picker" 
    [formControl]="control()" 
    [min]="minDate()"
    [max]="maxDate()"
    placeholder="DD/MM/AAAA" 
  />
  
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>